import type { FireIconProps } from './types';

export default function FireEngine({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Cab */}
      <path d="M1 14h5V8h4l2-3h2v9" />
      {/* Body */}
      <rect x="14" y="9" width="9" height="5" rx="0.5" />
      {/* Compartment lines */}
      <line x1="17" y1="9" x2="17" y2="14" />
      <line x1="20" y1="9" x2="20" y2="14" />
      {/* Light bar */}
      <rect x="2" y="6" width="3" height="2" rx="0.5" />
      {/* Undercarriage */}
      <line x1="1" y1="14" x2="23" y2="14" />
      {/* Wheels */}
      <circle cx="5" cy="17" r="2" />
      <circle cx="19" cy="17" r="2" />
      {/* Bumper */}
      <line x1="7" y1="15" x2="17" y2="15" />
    </svg>
  );
}
